import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type MyReportsEvents = 'TABLE_NAME_CELL_CLICK' | 'OPEN_CREATE_REPORT_FORM' | 'SAVE_CREATE_REPORT_FORM';

export const myReports: Record<MyReportsEvents, MixpanelEvent> = {
  TABLE_NAME_CELL_CLICK: {
    eventDescription: 'My Reports Table Name Cell Click',
    eventKey: 'myReports-table-name-cell-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  },
  OPEN_CREATE_REPORT_FORM: {
    eventDescription: 'User opens the create report form',
    eventKey: 'open-create-report-form',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  SAVE_CREATE_REPORT_FORM: {
    eventDescription: 'User opens the create report form',
    eventKey: 'open-create-report-form',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  }
} as const;
